import { type ReactElement } from 'react';
import { useAdminExperience } from 'eds-data-ux';

export interface ByRoleProps {
  admin: ReactElement;
  teacher: ReactElement;
}

/** Picks the element for the signed-in user, for the /data section. */
export function ByRole({ admin, teacher }: ByRoleProps) {
  const { showsAdminExperience, isLoading } = useAdminExperience();

  if (isLoading) return null;
  return showsAdminExperience ? admin : teacher;
}
